export default __webpack_public_path__ + "img/icon_left_arrow-b70e7bae617a8bdea103192ef61d67b5.png";